export interface ISimpleSapElement {
    feature: string;
    type: string;
    color: string;
}

export class SimpleSapElement implements ISimpleSapElement {

    public static ELEMENT(type: string, color: string) {
        return new SimpleSapElement('ELEMENT', type, color);
    }

    public static HANDLE(type: string, color: string) {
        return new SimpleSapElement('HANDLE', type, color);
    }

    public static LEG(type: string, color: string) {
        return new SimpleSapElement('LEG', type, color);
    }

    private constructor(
        public readonly feature: string,
        public readonly type: string,
        public readonly color: string,
    ) { }
}
